import AssetRecalcForm from './AssetRecalcForm'
export default AssetRecalcForm
